import { graphql } from "@/lib/gql/__generated__";

export const HotelTopQuery = graphql(/* GraphQL */ `
	query HotelTop($hotelID: ID!) {
		startGuide(hotelID: $hotelID) {
			id
			hotelID
			isHotelInfoRegistered
			isHotelPolicyRegistered
			isRoomRegistered
			isPlanRegistered
			isOptionRegistered
			isSiteControllerRegistered
			isPlainRegistered
			isCreditInfoRegistered
			isDepositAccountRegistered
			isBillingInfoRegistered
			isShowRoomPriceRank
			isRoomPriceRankRegistered
			isReservationExists
		}
		hotelTemplateSettings(hotelID: $hotelID) {
			id
			hotelID
			hotelTemplateType
			hotelTemplateTypeSelectable
		}
		hotelUrls(hotelID: $hotelID) {
			id
			urlMagazine
			urlSnack
			urlPlain
		}
	}
`);
